import classnames from 'classnames';
import assign from 'lodash.assign';

const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;

// Enable class control on the following blocks
const enableClassControlColumnsOnBlocks = [
    'core/columns'
];

/**
* Add class attribute to columns block
*/
const addClassSpacingColumnsAttribute = ( settings, name ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! enableClassControlColumnsOnBlocks.includes( name ) ) {
		return settings;
	}

    // Use Lodash's assign to gracefully handle if attributes are undefined
    settings.attributes = assign( settings.attributes, {
       classSpaceTop: {
           type: 'string',
           default: '',
       },
       classSpaceBottom: {
           type: 'string',
           default: '',
       }
    });

    return settings;
};
addFilter( 'blocks.registerBlockType', 'clayi/class-columns/add-class-spacing-columns-attribute', addClassSpacingColumnsAttribute );

/**
* Add class control to inspector 
*/
const addClassSpacingColumnsInspectorControl = createHigherOrderComponent( ( BlockEdit ) => {
    return ( props ) => {
        const {
            attributes: { classSpaceTop, classSpaceBottom },
            setAttributes,
            name,
        } = props;

        // Do nothing if it's another block than our defines ones.
		if ( ! enableClassControlColumnsOnBlocks.includes( props.name ) ) {
			return (
				<BlockEdit { ...props } />
			);
		}

        return (
            <Fragment>
                <BlockEdit { ...props } />

                <InspectorControls>
                    <PanelBody
						title={ __( 'Group Space Options', 'clayi' ) }
						initialOpen={ true }
					>
						<SelectControl
							label={ __( 'Space top', 'clayi' ) }
							value={ classSpaceTop }
							options={[
								{
									label: __( 'Default', 'clayi' ),
									value: '',
								},
								{
									label: __( 'Smaller', 'clayi' ),
									value: 'smaller',
								},
								{
									label: __( 'Small', 'clayi' ),
									value: 'small',
								},
								{
									label: __( 'Medium', 'clayi' ),
									value: 'medium',
								},
								{
									label: __( 'Large', 'clayi' ),
									value: 'large',
								},
							]}
							onChange={ ( value ) => {
								setAttributes({ classSpaceTop: value});
							}}
						/>

                        <SelectControl
							label={ __( 'Space bottom', 'clayi' ) }
							value={ classSpaceBottom }
							options={[
								{
									label: __( 'Default', 'clayi' ),
									value: '',
								},
								{
									label: __( 'Smaller', 'clayi' ),
									value: 'smaller',
								},
								{
									label: __( 'Small', 'clayi' ),
									value: 'small',
								},
								{
									label: __( 'Medium', 'clayi' ),
									value: 'medium',
								},
								{
									label: __( 'Large', 'clayi' ),
									value: 'large',
								},
							]}
							onChange={ ( value ) => {
								setAttributes({ classSpaceBottom: value});
							}}
						/>
                        
                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    }
}, 'addClassSpacingColumnsInspectorControl' );
addFilter( 'editor.BlockEdit', 'clayi/class-columns/add-class-spacing-columns-inspector-control', addClassSpacingColumnsInspectorControl );

/**
* Add class to the block in the editor
*/
const addClassSpacingColumnsEditorInspectorControl = createHigherOrderComponent( ( BlockListBlock ) => {
    return ( props ) => {
		const {
			attributes: { classSpaceTop, classSpaceBottom },
			className,
			name,
		} = props;

		// Do nothing if it's another block than our defined ones.
		if ( ! enableClassControlColumnsOnBlocks.includes( props.name ) ) {
			return (
				<BlockListBlock { ...props } />
			);
		}

        return (
            <BlockListBlock
                {...props}
				className={
                    classnames(
                        className, 
                        classSpaceTop ? `has-space-top-${classSpaceTop}` : '',
                        classSpaceBottom ? `has-space-bottom-${classSpaceBottom}` : ''
                    )
                }
            />
        );
    }
}, 'addClassSpacingColumnsEditorInspectorControl' );
addFilter( 'editor.BlockListBlock', 'clayi/class-columns/add-class-spacing-columns-editor-inspector-control', addClassSpacingColumnsEditorInspectorControl );

/**
* Add class to the block in the front-end
*/
function addClassSpacingColumnsFrontend( props, blockType, attributes) {
	// Do nothing if it's another block than our defined ones.
	if ( ! enableClassControlColumnsOnBlocks.includes( blockType.name ) ) {
		return props;
	}

    const { className } = props;
    const { classSpaceTop, classSpaceBottom } = attributes;

    return assign( {}, props, {
        className: classnames(
            className, 
            classSpaceTop ? `has-space-top-${classSpaceTop}` : '',
            classSpaceBottom ? `has-space-bottom-${classSpaceBottom}` : ''
        ),
    });
}
addFilter( 'blocks.getSaveContent.extraProps', 'clayi/class-columns/add-class-spacing-columns-frontend', addClassSpacingColumnsFrontend );
